// src/hooks/use-click-outside.js
import { onMounted, onUnmounted } from "vue";

/**
 * Detecta clique fora de um ou mais refs e chama callback
 * @param {Array} refs - array de refs do Vue
 * @param {Function} callback - função chamada ao clicar fora
 */
export function useClickOutside(refs, callback) {
  const handleClick = (event) => {
    // verifica se clicou fora de todos os elementos
    const clickedOutside = refs.every(
      (r) => !r.value || !r.value.contains(event.target)
    );

    if (clickedOutside && typeof callback === "function") {
      callback(event);
    }
  };

  onMounted(() => window.addEventListener("mousedown", handleClick));
  onUnmounted(() => window.removeEventListener("mousedown", handleClick));
}
